"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDevices = exports.AlertTypes = void 0;
exports.AlertTypes = {
    Global: 'global',
    LoggedIn: 'loggedIn',
    LoggedOut: 'loggedOut',
};
exports.AlertDevices = {
    App: 'Application',
    Web: 'Web'
};
exports.default = { AlertTypes: exports.AlertTypes, AlertDevices: exports.AlertDevices };
//# sourceMappingURL=Alert.js.map